/* Skin Diligent — Skin Diagnostic (US), engine v3
   Logic per skin-diagnostic-developer-changes-v3.md + quiz-klaviyo-developer-spec (2026-07-29).
   Content comes from the #sd-content JSON emitted by sections/skin-diagnostic.liquid
   (metaobjects, or the baked-in fallback). No customer wording lives in this file.
*/

/* ---- Shopify data (us.skindiligent.com, verified 2026-07-29) ---- */
var PRODUCTS = {
  hydration:   { name: "Cellular Hydration Serum",     price: 80,  handle: "cellular-hydration-serum",     variantId: 46249963094283 },
  vitamin_c:   { name: "Vitamin C Serum-in-Oil",       price: 90,  handle: "vitamin-c",                    variantId: 46249862430987 },
  cel_retinal: { name: "CEL™ Retinal Serum",      price: 105, handle: "cel-retinal-serum",            variantId: 53128946155787 },
  exosome:     { name: "Exosome Advanced Night Cream", price: 125, handle: "exosome-advanced-night-cream", variantId: 46095475573003 }
};
/* Standard bundles: sold as ONE line item at the system price when the resolved
   composition matches; otherwise individual products are added (same totals). */
var SYSTEMS = {
  morning:   { name: "The Morning System",   variantId: 53276891775243, products: ["hydration","vitamin_c"] },
  night:     { name: "The Night System",     variantId: 53276895609099, products: ["cel_retinal","exosome"] },
  longevity: { name: "The Longevity System", variantId: 53276896297227, products: ["hydration","vitamin_c","cel_retinal","exosome"] }
};

/* ---- Klaviyo (quiz-klaviyo-developer-spec + tracking-additions, 2026-07-30) ----
   Quiz takers go to "Quiz Leads (US)" ONLY — never the Email List (W6HpnK):
   the list separation alone keeps them out of the guide welcome flow
   (Signup Source was dropped by spec). Every completion also fires the
   "Completed Skin Quiz" event (EXACT name, Klaviyo reports depend on it).
   Tell the growth team before changing the list id or the event name. */
var KLAVIYO_COMPANY_ID = "RzKitK";
var KLAVIYO_REVISION   = "2024-10-15";
var KLAVIYO_LIST_ID    = "RkxXCh";

var TAG_BY_AGE = { "20s": "prevention", "30s": "prevention", "40s": "perimenopause", "50plus": "longevity" };
var TIER_BY_APPETITE = { one_step: "begin", ritual: "core", full: "complete" };

/* ============ ENGINE (no customer wording below) ============ */
(function(){
  var host = document.getElementById("sd-app");
  if(!host) return;
  var C = JSON.parse(document.getElementById("sd-content").textContent);
  var IMG = {};
  try{ var ie = document.getElementById("sd-images"); if(ie) IMG = JSON.parse(ie.textContent) || {}; }catch(e){}

  C.questions.forEach(function(q){
    q.opts = (q.options||"").split("\n").map(function(l){
      var p = l.split("|"); return { value:(p[0]||"").trim(), label:(p[1]||"").trim() };
    }).filter(function(o){ return o.value; });
  });

  var state = { step:0, answers:{} };
  var Q = C.questions, S = C.shared;

  function pctW(){ return Math.round((state.step/(Q.length+1))*100); }
  function bar(){ return '<div class="sd-progress"><div class="sd-bar" style="width:'+pctW()+'%"></div></div>'; }

  function render(){
    if(state.step < Q.length) return renderQ();
    if(state.step === Q.length) return renderEmail();
    return renderResult();
  }

  function renderQ(){
    var q = Q[state.step], chosen = state.answers[q.id];
    var h = bar()+'<div class="sd-qnum">Question '+(state.step+1)+' of '+Q.length+'</div>';
    h += '<h1 class="sd-qtext">'+q.text+'</h1>';
    if(q.helper) h += '<p class="sd-helper">'+q.helper+'</p>';
    h += '<div class="sd-options">';
    q.opts.forEach(function(o){ h += '<button class="sd-opt'+(chosen===o.value?' sel':'')+'" data-v="'+o.value+'">'+o.label+'</button>'; });
    h += '</div><div class="sd-nav">';
    h += state.step>0 ? '<span class="sd-back" id="b">Back</span>' : '<span></span>';
    if(String(q.optional)==="true") h += '<span class="sd-skip" id="s">Skip this</span>';
    h += '</div>';
    host.innerHTML = h;
    host.querySelectorAll(".sd-opt").forEach(function(btn){ btn.onclick=function(){ state.answers[q.id]=btn.dataset.v; next(); }; });
    if(host.querySelector("#b")) host.querySelector("#b").onclick=prev;
    if(host.querySelector("#s")) host.querySelector("#s").onclick=function(){ state.answers[q.id]=null; next(); };
  }

  function renderEmail(){
    var e = C.email;
    var h = bar()+'<div class="sd-eyebrow">'+e.eyebrow+'</div><h1 class="sd-qtext">'+e.title+'</h1>';
    h += '<p class="sd-helper">'+e.body+'</p>';
    h += '<input id="sd-email" class="sd-email" type="email" placeholder="'+e.placeholder+'" autocomplete="email" inputmode="email">';
    h += '<p class="sd-field-err" id="sd-err" hidden></p>';
    h += '<label class="sd-consent"><input type="checkbox" id="sd-consent"><span>'+e.consent+'</span></label>';
    h += '<button class="sd-btn sd-accent sd-block" id="go">'+e.button+'</button>';
    h += '<div class="sd-nav"><span class="sd-back" id="b">Back</span><span></span></div>';
    host.innerHTML = h;
    host.querySelector("#b").onclick = prev;
    var emailInput = host.querySelector("#sd-email"), errLine = host.querySelector("#sd-err");
    function fail(msg){ errLine.textContent = msg; errLine.hidden = false; }
    host.querySelector("#go").onclick = function(){
      errLine.hidden = true;
      emailInput.style.borderColor = "";
      host.querySelector(".sd-consent").style.color = "";
      var em = emailInput.value.trim();
      if(!em || em.indexOf("@")<1 || em.indexOf(".", em.indexOf("@"))<0){
        emailInput.style.borderColor = "#c0392b";
        return fail("Please enter a valid email address.");
      }
      if(!host.querySelector("#sd-consent").checked){
        host.querySelector(".sd-consent").style.color = "#c0392b";
        return fail("Please tick the box above to receive your reading.");
      }
      state.answers.email = em;
      saveLead(em, state.answers);
      next();
    };
    emailInput.addEventListener("keydown", function(ev){ if(ev.key === "Enter") host.querySelector("#go").click(); });
  }

  /* ---- v3 recommendation logic ---- */
  function uniq(arr){ var o=[]; arr.forEach(function(x){ if(x && o.indexOf(x)<0) o.push(x); }); return o; }

  function buildProducts(heroKey, depth, isTwenties){
    if(depth === "one_step") return [heroKey];
    var isNightHero = (heroKey === "cel_retinal" || heroKey === "exosome");
    var system = isNightHero ? ["cel_retinal","exosome"] : ["hydration","vitamin_c"];
    if(depth === "ritual"){
      if(isTwenties) system = system.map(function(p){ return p === "cel_retinal" ? "hydration" : p; });
      return uniq(system);
    }
    if(isTwenties) return ["hydration","vitamin_c","exosome"];
    return ["hydration","vitamin_c","cel_retinal","exosome"];
  }

  function resolve(){
    var a = state.answers;
    var concern = a.concern || "unsure";
    var feel = a.feel, age = a.age, when = a.when, depth = a.routine || "ritual";
    var isTwenties = (age === "20s");

    var R = C.results[concern] || C.results.unsure;
    var origHero = R.hero;
    var heroKey = origHero;
    var notes = [];

    if(isTwenties && heroKey === "cel_retinal"){
      heroKey = "vitamin_c";
      if(C.results.firmness20s){ R = C.results.firmness20s; }
    }

    var products      = buildProducts(heroKey, depth, isTwenties);
    var productsAdult = buildProducts(origHero, depth, false);
    var retinalRemoved = isTwenties &&
        productsAdult.indexOf("cel_retinal") > -1 &&
        products.indexOf("cel_retinal") < 0;
    if(retinalRemoved && S.note20s) notes.push(S.note20s);

    var addendum = (feel === "sensitive" && concern !== "comfort" && S.sensitiveAddendumBody) ? {
      title: S.sensitiveAddendumTitle, body: S.sensitiveAddendumBody
    } : null;

    if(heroKey === "vitamin_c"  && when === "evening" && C.notes.vitcEvening) notes.push(C.notes.vitcEvening);
    if(heroKey === "cel_retinal" && when === "morning" && C.notes.retinalMorning) notes.push(C.notes.retinalMorning);
    if(products.indexOf("cel_retinal") > -1 && C.notes.retinalSlow) notes.push(C.notes.retinalSlow);
    if(products.indexOf("exosome") > -1 && when === "morning" && C.notes.exosomeMorning) notes.push(C.notes.exosomeMorning);

    var oneProductNote = (depth === "one_step" && S.oneProductNote) ? {
      body: S.oneProductNote, link: S.oneProductLink
    } : null;

    var routineKey = R.defaultRoutine || "morning";
    if(R.timeNature === "flexible" && when === "evening") routineKey = "nightHydration";

    return {
      R: R, heroKey: heroKey, products: products,
      addendum: addendum, notes: uniq(notes),
      oneProductNote: oneProductNote,
      whenLabel: labelFor("when", when),
      tier: TIER_BY_APPETITE[depth] || "core",
      isTwenties: isTwenties,
      routine: C.routines[routineKey]
    };
  }

  function priceOf(keys){ var t=0; keys.forEach(function(k){ t += PRODUCTS[k].price; }); return "$"+t; }
  function matchSystem(keys){
    var sorted = keys.slice().sort().join(",");
    for(var s in SYSTEMS){ if(SYSTEMS[s].products.slice().sort().join(",") === sorted) return s; }
    return null;
  }
  function namesOf(keys){
    /* prefer "The Morning System + X" over three raw product names */
    var rest = keys.slice();
    if(rest.indexOf("hydration") > -1 && rest.indexOf("vitamin_c") > -1){
      rest = rest.filter(function(k){ return k !== "hydration" && k !== "vitamin_c"; });
      return [SYSTEMS.morning.name].concat(rest.map(function(k){ return PRODUCTS[k].name; })).join(" + ");
    }
    return keys.map(function(k){ return PRODUCTS[k].name; }).join(" + ");
  }

  function renderResult(){
    var r = resolve(), R = r.R;
    var hero = PRODUCTS[r.heroKey];
    /* the three buyable tiers, sized by the v3 rules */
    var tiers = {
      begin:    { keys: [r.heroKey] },
      core:     { keys: buildProducts(r.heroKey, "ritual", r.isTwenties) },
      complete: { keys: buildProducts(r.heroKey, "full",   r.isTwenties) }
    };
    for(var t in tiers){
      var sysKey = matchSystem(tiers[t].keys);
      tiers[t].sysKey = sysKey;
      tiers[t].name = (t === "begin") ? hero.name : (sysKey ? SYSTEMS[sysKey].name : namesOf(tiers[t].keys));
      tiers[t].price = priceOf(tiers[t].keys);
      tiers[t].img = (t === "begin") ? IMG[r.heroKey] : (IMG[sysKey] || IMG[tiers[t].keys[0]] || null);
    }

    var h = '<div class="sd-result">';
    h += '<div class="sd-eyebrow c">'+S.resultEyebrow+'</div><h1 class="sd-rh">'+R.headline+'</h1>';
    h += '<div class="sd-sub">'+R.subline+'</div>';
    h += '<div class="sd-card"><div class="sd-k">'+S.summaryTitle+'</div>';
    h += row(S.summaryPriority, labelFor("concern", state.answers.concern));
    h += row(S.summaryFeel, labelFor("feel", state.answers.feel));
    h += row(S.summaryTime, r.whenLabel)+'</div>';
    h += '<p class="sd-reading">'+R.reading+'</p>';
    var heroMedia = IMG[r.heroKey] ? '<img class="sd-hero-img" src="'+IMG[r.heroKey]+'" alt="'+hero.name+'" loading="lazy">' : '<div class="sd-ph">Product image</div>';
    h += '<div class="sd-block"><div class="sd-lbl">'+S.heroLabel+'</div><div class="sd-hero">'+heroMedia+'<div class="sd-hb"><h3>'+hero.name+'</h3><div class="sd-price">$'+hero.price+'</div><p>'+R.heroText+'</p></div></div></div>';
    if(r.addendum) h += '<div class="sd-addendum"><div class="sd-lbl">'+r.addendum.title+'</div><p>'+r.addendum.body+'</p></div>';
    h += '<div class="sd-constant">'+S.constant+'</div>';
    h += '<div class="sd-block"><div class="sd-lbl">'+S.ladderTitle+'</div><div class="sd-ladder">';
    h += rung("begin",    tiers.begin,    S.ladderBeginLabel,    S.ladderBeginNote,    r.tier);
    h += rung("core",     tiers.core,     S.ladderCoreLabel,     S.ladderCoreNote,     r.tier);
    h += rung("complete", tiers.complete, S.ladderCompleteLabel, S.ladderCompleteNote, r.tier);
    h += '</div></div>';
    h += '<div class="sd-block"><div class="sd-lbl">'+S.ritualLabel+'</div><p>'+r.routine+'</p>';
    r.notes.forEach(function(n){ h += '<p class="sd-note">'+n+'</p>'; });
    h += '</div>';
    if(r.oneProductNote){
      h += '<div class="sd-oneproduct"><p>'+r.oneProductNote.body+(r.oneProductNote.link ? ' <a href="'+r.oneProductNote.link+'">Hydration vs Moisturization</a>.' : '')+'</p></div>';
    }
    if(R.testersIntro || R.testersDay28 || R.testersDay56){
      h += '<div class="sd-testers">';
      if(R.testersIntro) h += '<p>'+R.testersIntro+'</p>';
      if(R.testersDay28) h += '<p><b>At 28 days,</b> '+R.testersDay28+'</p>';
      if(R.testersDay56) h += '<p><b>At 56 days,</b> '+R.testersDay56+'</p>';
      if(R.testersLink)  h += '<span class="sd-lnk">'+R.testersLink+'</span>';
      h += '</div>';
    }
    h += '<div class="sd-block"><div class="sd-lbl">'+R.whyTitle+'</div><p>'+R.whyBody+'</p></div>';
    if(S.proofNote) h += '<div class="sd-proof">'+S.proofNote+'</div>';
    h += '<div class="sd-actions"><a class="sd-btn sd-ghost sd-block" href="/products/'+hero.handle+'">'+S.ctaSecondary+'</a></div>';
    if(S.savedTemplate) h += '<div class="sd-saved">'+S.savedTemplate.replace("{email}", state.answers.email||"your inbox")+'</div>';
    h += '<div class="sd-lab">'+S.labLine+'</div><div class="sd-reassure">'+S.reassurance+'</div></div>';
    host.innerHTML = h;
    host.querySelectorAll(".sd-rung-buy").forEach(function(btn){
      btn.onclick = function(){ buyTier(tiers[btn.dataset.tier]); };
    });
  }

  function rung(key,tier,label,note,recTier){
    var rec = key===recTier;
    var h = '<div class="sd-rung'+(rec?' rec':'')+'">'+(rec?'<span class="sd-badge">'+S.recommendedBadge+'</span>':'');
    h += '<div class="sd-rung-row">';
    if(tier.img) h += '<img class="sd-rung-thumb" src="'+tier.img+'" alt="'+tier.name+'" loading="lazy">';
    h += '<div class="sd-rung-body"><div class="sd-rk">'+label+'</div><h3>'+tier.name+'</h3>';
    h += '<div class="sd-price">'+tier.price+'</div>';
    h += '<p>'+note+'</p></div></div>';
    h += '<button class="sd-btn sd-rung-buy'+(rec?' sd-accent':' sd-quiet')+'" data-tier="'+key+'">'+(S.rungCta||"Add to cart")+'</button>';
    h += '</div>';
    return h;
  }
  function row(a,b){ return '<div class="sd-row"><span>'+a+'</span><span>'+(b||"—")+'</span></div>'; }
  function labelFor(qid,val){ var q=Q.find(function(x){return x.id===qid;}); if(!q)return val||"—"; var o=q.opts.find(function(x){return x.value===val;}); return o?o.label:(val||"—"); }

  /* ---- Cart: standard system -> ONE bundle line at the system price, with a
     fallback to the individual products if the bundle is unavailable. Non-standard
     compositions (e.g. the 20s routines) always add the individual products. ---- */
  function addItems(items){
    return fetch("/cart/add.js", { method:"POST", headers:{ "Content-Type":"application/json" }, body: JSON.stringify({ items: items }) });
  }
  function buyTier(tier){
    var parts = tier.keys.map(function(k){ return { id: PRODUCTS[k].variantId, quantity: 1 }; });
    var bundle = (tier.sysKey && tier.keys.length > 1) ? [{ id: SYSTEMS[tier.sysKey].variantId, quantity: 1 }] : null;
    if(window.SD_DEMO){ alert("[demo] add to cart: "+JSON.stringify(bundle||parts)); return; }
    (bundle ? addItems(bundle).then(function(res){ return res.ok ? res : addItems(parts); }) : addItems(parts))
      .then(function(){ window.location.href = "/cart"; })
      .catch(function(){ window.location.href = "/cart"; });
  }

  /* ---- Klaviyo: Quiz Leads list only + Signup Source = Quiz + answer tags ---- */
  function saveLead(email, answers){
    var ageTag = (answers.age && TAG_BY_AGE[answers.age]) ? TAG_BY_AGE[answers.age] : "";
    var props = {
      sd_age_tag: ageTag,
      sd_concern_tag: answers.concern || "",
      sd_feel: answers.feel || "",
      sd_routine: answers.routine || "",
      sd_when: answers.when || "",
      sd_age: answers.age || "",
      sd_answers: JSON.stringify(answers)
    };
    if(window.SD_DEMO){ console.log("[demo] saveLead", email, props); return; }
    var base = "https://a.klaviyo.com/client/", headers = { "Content-Type":"application/json", "revision": KLAVIYO_REVISION };
    fetch(base+"profiles/?company_id="+KLAVIYO_COMPANY_ID, { method:"POST", headers:headers, body: JSON.stringify({
      data:{ type:"profile", attributes:{ email:email, properties:props } }
    })}).catch(function(){});
    fetch(base+"subscriptions/?company_id="+KLAVIYO_COMPANY_ID, { method:"POST", headers:headers, body: JSON.stringify({
      data:{ type:"subscription",
        attributes:{ custom_source:"Skin Diagnostic", profile:{ data:{ type:"profile", attributes:{ email:email, properties:props } } } },
        relationships:{ list:{ data:{ type:"list", id:KLAVIYO_LIST_ID } } } }
    })}).catch(function(){});
    /* reporting event — exact name "Completed Skin Quiz" (Analytics > Metrics) */
    fetch(base+"events/?company_id="+KLAVIYO_COMPANY_ID, { method:"POST", headers:headers, body: JSON.stringify({
      data:{ type:"event", attributes:{
        properties:{ "Concern": answers.concern||"", "Skin Feel": answers.feel||"", "Routine Depth": answers.routine||"", "Best Time": answers.when||"", "Age": answers.age||"" },
        metric:{ data:{ type:"metric", attributes:{ name:"Completed Skin Quiz" } } },
        profile:{ data:{ type:"profile", attributes:{ email:email } } }
      } }
    })}).catch(function(){});
  }

  function next(){ state.step++; window.scrollTo(0,0); render(); }
  function prev(){ if(state.step>0){ state.step--; window.scrollTo(0,0); render(); } }
  render();
})();
